// extracted by mini-css-extract-plugin
export default {"columnTitle":"useHeaderColumnProps_columnTitle__VbxjL","placeHolderShimmer":"useHeaderColumnProps_placeHolderShimmer__Kmcii"};